<template>
    <div class="col-12 mt-2" >
        <div class="border rounded p-3 bg-secondary" >
            <transition-group mode="out-in">
               <form-payment-type-cc v-show="paymentType == 'cc'" key="pay-method-cc" v-model="cc_data" ref="cc_form"></form-payment-type-cc>

                <div class="pay-method-detail pay-instructions border rounded" v-show="paymentType == 'check'" key="pay-method-check">
                    <div v-if="$parent.event.CheckPayInstructions">
                        <p v-html="$parent.event.CheckPayInstructions"></p>
                    </div>
                    <div v-else>
                        <p>Please, make checks or money orders payable to the <i>East Central Ohio ESC.</i> Payment must be recieved within five days of enrolling in an event.</p>
                        <p><b>Please mail payments to:</b></p>
                        <ul>
                            <li>East Central Ohio ESC</li>
                            <li>&incare; ECOESC Office Manager</li>
                            <li>834 East High Ave</li>
                            <li>New Philadelphia, OH 44663</li>
                        </ul>
                    </div>
                </div>

                <div class="pay-method-detail" v-show="paymentType == 'po'" key="pay-method-po">
                    <div v-if="$parent.event.POPayInstructions">
                        <p v-html="$parent.event.POPayInstructions"></p>
                    </div>
                    <input class="form-control" type="text" id="pay-po-no" :required="paymentType == 'po'" v-model="po_no" />
                    <label for="pay-po-no" class="form-label">Purchase Order Number</label> 
                </div>

                <div class="pay-method-detail" v-show="paymentType == 'aa'" key="pay-method-aa">
                    <input class="form-control" type="text" id="pay-aa-code" :required="paymentType == 'aa'" v-model="aa_code" />
                    <label for="pay-aa-code" class="form-label">PD Consortium Code</label> 
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import FormPaymentTypeCc from './FormPaymentTypeCc.vue';

export default {
    components: { FormPaymentTypeCc },

    props: {
        paymentType: {
            required: true,
            default: null,
            validator: prop => typeof prop === 'string' || prop === null
        },

        value: {
            required: true,
            default: function(data={}) {
                return {};
            }
        }
    },

    updated() {
        const data = {
            cc_data: this.cc_data,
            po_no: this.po_no,
            aa_code: this.aa_code,
        };

        this.$emit('input', data);
    },

    data() {
        return {
            cc_data: {
                first_name: '',
                last_name: '',
                email: '',
                token: ''
            },
            po_no: '',
            aa_code: '',

        }
    },


}
</script>

<style scoped>
    .fade-enter-active {
        animation: wait-and-fade-in .25s;
    }
    
    .fade-leave-active {
        animation: fade-out .25s;
    }

    @keyframes wait-and-fade-in {
        0% {
            opacity: 0;
        }
        
        66% {
            opacity: 0;
        }
        
        100% {
            opacity: 1;
        }
    }
    
    @keyframes fade-out {
        0% {
            opacity: 1;
        }
        
        50% {
            opacity: 0;
        }
        
        100% {
            opacity: 0;
        }
    }

    .pay-instructions {
        padding: .5em 1em .1em;
        margin-bottom: 1em;
    }
    
    .pay-instructions ul {
        padding-left: 2em;
    }
</style>